/**
 * Part of senka project.
 *
 * @copyright  Copyright (C) 2021 {ORGANIZATION}. All rights reserved.
 * @license    GNU General Public License version 2 or later.
 */

require('./bootstrap');

window.Vue = require('vue').default;

Vue.component('canvas-component', require('./components/CanvasComponent.vue').default);

new Vue({
    el: '#app'
});
